const phonesDB = {
  main: {
    label: "Основной",
    value: "+7 (977) 090-60-36",
    href: "tel:+79770906036",
  },

  additional: [
    {
      label: "Отдел продаж",
      value: "+7 (985) 897-25-69",
      href: "tel:+79858972569",
    },
    // {
    //   label: "Логистика",
    //   value: "+7 (999) 333-44-55",
    //   href: "tel:+79993334455",
    // },
    // {
    //   label: "Бухгалтерия",
    //   value: "+7 (999) 444-55-66",
    //   href: "tel:+79994445566",
    // },
  ],
};

export default phonesDB;
